<template>
  <div class="timeline-calendar__row">
    <div
      v-for="month in months"
      class="timeline-calendar__months timeline-calendar__item"
      :data-grid-columns="gridColumnsCount(month)"
    >
      <span class="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
        {{ month.name }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const model = defineModel({
  type: Object,
  required: true,
  default: () => ({}),
});

const months = computed(() => model.value.grid.value.months);
const gridColumnsCount = (month) => {
  return model.value.showDays ? month.days : month.weeks;
};
</script>
